import { useState, useEffect } from 'react';
import Timer from '../components/Timer';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';

const mission = {
    time: 40 // 40 minutes
}
export default function Mission4(props) {
    const isMobile = window.innerWidth <= 1024
    const [remainingTime, setremainingTime] = useState(40 * 60); //40 mins
    const [startTime, setStartTime] = useState(new Date());
    const getRemainingTimeString = () => {
        if ((!remainingTime) || remainingTime <= 0) return '00:00'
        let time = remainingTime
        let hours = Math.floor(time / 3600);
        let minutes = Math.floor((time - (hours * 3600)) / 60);
        let seconds = Math.floor(time - (hours * 3600) - (minutes * 60));
        //return `${hours < 10 ? `0` : ''}${hours}:${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
        return `${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
    }
    useEffect(() => {
        let timeInterval = null
        timeInterval = setInterval(() => {
            let second = (startTime.getTime() + mission.time * 60 * 1000 - Date.now()) / 1000
            setremainingTime(second <= 0 ? 0 : second)
        }
            , 1000)
        return () => { clearInterval(timeInterval) }
    }, [startTime])


    const [question1TabIndex, setQuestion1TabIndex] = useState(0);
    const [question1SelectedAnswers, setQuestion1SelectedAnswers] = useState([]);
    const [question1PopupVisible, setQuestion1PopupVisible] = useState(false);

    const [question2TabIndex, setQuestion2TabIndex] = useState(0);
    const [question2SelectedAnswers, setQuestion2SelectedAnswers] = useState([]);
    const [question2PopupVisible, setQuestion2PopupVisible] = useState(false);

     const [showWrongAnswerPopup, setShowWrongAnswerPopup] = useState(false);

    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[black]' style={{ overflowY: "auto", fontSize: isMobile ? 12 : '1.5rem' }}>
            {/*header*/}
            <div className='w-full flex flex-row justify-between items-center bg-[black]' style={{ gap: isMobile ? '4px' : '16px', overflow: 'auto', paddingLeft: isMobile ? 8 : 24, paddingRight: isMobile ? 8 : 24, height: isMobile ? 50 : 65 }}>
                <Timer text={getRemainingTimeString()} percentage={(1 - ((remainingTime || 0) / ((mission.time * 60) || 1))) * 100} />
            </div>
            {/*end of header*/}

            {/*content*/}
            <div className='flex flex-row w-full flex-1 bg-[#D9D9D9]' style={{ overflow: 'hidden' }}>
                {/*webpages*/}
                <div className='flex flex-col w-full bg-[white]' style={{ border: isMobile ? '2px solid black' : '2px solid black', padding: isMobile ? 4 : 10 }}>

                    <div className='w-full flex flex-row bg-[white] items-center' style={{ border: isMobile ? '2px solid black' : '2px solid black', marginTop: 4, marginBottom: 4, gap: isMobile ? 2 : 6, padding: isMobile ? 2 : 6 }}>
                        <div className='cursor-pointer'>
                            <PreviousSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='cursor-pointer'>
                            <NextSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='cursor-pointer'>
                            <ReloadSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='flex-1'>
                            <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={'https://reading-practice.com'} style={{ fontSize: isMobile ? 10 : 16, height: isMobile ? 26 : 40, paddingLeft: isMobile ? 12 : 24, paddingRight: isMobile ? 12 : 24 }} />
                        </div>
                    </div>
                    {/*end tabs*/}

                    {/*web content*/}
                    <div className='flex w-full flex-1 bg-[white] flex-col justify-start' style={{ overflowY: 'auto', border: '2px solid black' }}>
                        <img src='/閱讀策略/4-01.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />

                        <div className='w-full bg-[#DDF6F2] flex flex-col justify-start p-[32px] items-center'>
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                網絡上常會流傳各種真真假假的消息，所以，我們閱讀網站內容時，不能只看見就相信，要仔細檢查訊息是否可靠。
                            </div>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                怎麼學？兩步教你做判斷
                            </div>
                           </div>
                        <img src='/閱讀策略/task4-00.png' style={{ maxWidth: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <img src='/閱讀策略/b1.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />

                        <div className='w-full bg-[#E3F2FE] flex flex-col justify-start p-[32px] items-center'>
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                <u>小華</u>在瀏覽「 <u>香港野生動物保育網</u>」時，看到下面這段介紹：<br />
                                「野生大熊貓主要生活在高山竹林裏。 <u>海洋公園 </u>的大熊貓 <u>加加</u>和 <u>得得</u>，每天都要吃掉很多竹子。」<br />
                                過了一會兒， <u>小華</u>又在一個匿名討論區看到網友留言：<br />
                                「世紀大發現！原來大熊貓最喜歡吃的食物是薯條！」<br />
                                <u>小華</u>想知道「大熊貓到底吃什麼？」，他應該相信網站介紹，還是匿名討論區呢？<br />
                                <br />
                                我們可以用兩步來做判斷：首先「看來源」：「香港野生動物保育網」是專門介紹動物的可靠網站，比匿名的討論區更具公信力；接着「找證據」：網站提出了熊貓吃竹子的事實，而討論區只用「世紀大發現」吸引人，卻拿不出任何證明，所以網站的訊息較可靠。

                            </div>
                            <br />
                            <img src='/閱讀策略/4-02.png' style={{ maxWidth: 'min(100%, 1000px)', objectFit: 'contain' }} alt='閱讀策略' />



                        </div>
                        <img src='/閱讀策略/b2.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <div className='w-full bg-[#DDFBF6] flex flex-col justify-start p-[32px] items-center'>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>

                                同學們，學會了「判定網站上訊息是否可靠」策略後，現在輪到你們試一試啦！
                                <br />
                                <br />
                                <br />


                                {/*tab*/}
                                <div className='flex flex-row w-full justify-start gap-[16px]'>
                                    <div className={`${question1TabIndex === 0 ? 'bg-[#D9D9D9]' : 'bg-[#888888]'} px-[16px] py-[2px] cursor-pointer`} style={{ border: '2px solid black', borderBottom: 'none', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }}
                                        onClick={() => setQuestion1TabIndex(0)}
                                    >
                                        網頁一：世界盃的真假消息
                                    </div>
                                    <div className={`${question1TabIndex === 1 ? 'bg-[#D9D9D9]' : 'bg-[#888888]'} px-[16px] py-[2px] cursor-pointer`} style={{ border: '2px solid black', borderBottom: 'none', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }}
                                        onClick={() => setQuestion1TabIndex(1)}
                                    >
                                        網頁二：匿名球迷討論區
                                    </div>
                                </div>
                                {question1TabIndex === 0 &&
                                    <div className='flex flex-col w-full bg-white items-center'>
                                        <img src='/閱讀策略/4-03.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                                        <br />
                                        <br />
                                        <div className='w-full max-w-[1000px] px-[32px]' style={{ textAlign: 'justify' }}>
                                            國際足協官方網站（FIFA.com） 官方發言人表示，為了鼓勵更多年輕人參與足球運動，下屆世界盃將會增設「最佳青年球員獎」，由專業評審團選出表現最出色的 21 歲以下球員。所有得獎名單與投票數據，都會在官方網站上公開發佈，確保公平公正。
                                        </div>
                                        <br />
                                        <br />


                                    </div>
                                }
                                {question1TabIndex === 1 &&
                                    <div className='flex flex-col w-full bg-white items-center'>
                                        <img src='/閱讀策略/4-06.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                                        <br />
                                        <br />
                                        <div className='w-full max-w-[800px] flex flex-row items-stretch'>
                                            <div className='flex flex-col items-center bg-[#E0F8FF] p-[16px]'>
                                                <img src='/閱讀策略/4-07.png' style={{ maxWidth: '200px', objectFit: 'contain', margin: '24px' }} alt='閱讀策略' />
                                                <div className=''>
                                                    「足球狂熱小超人」
                                                </div>
                                            </div>
                                            <div className='w-full max-w-[1000px] px-[32px] bg-[#eee] p-[16px]' style={{ textAlign: 'justify' }}>
                                                驚天大秘密！<br /><br />聽說下屆世界盃的冠軍獎盃「大力神盃」將會全面換成純金打造的「黃金足球盃」！因為<u>國際足協</u>覺得原本的「大力神盃」造型太舊了。聽說只要在社交平台轉發這個貼文十次，就有機會免費獲得決賽門票一張，大家快點轉發啊！
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                    </div>
                                }
                            </div>



                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px] max-w-[700px] bg-[#E3F2FE] p-[16px]'>
                                <div className='w-full'>
                                    1. 以下哪一個原因最能解釋為甚麼「網頁一」的訊息比「網頁二」更可靠？
                                </div>
                                {[
                                    { text: "A. 網頁一是由官方機構發佈且有發言人負責，還承諾公開數據。 ", id: 'A' },
                                    { text: "B. 網頁二的發佈者是一位非常有名的巴西國家隊職業球員。 ", id: 'B' },
                                    { text: "C. 網頁二承諾只要轉發貼文就能得到免費門票，因此非常可信。 ", id: 'C' },
                                    { text: "D. 網頁二的內容是由網民隨意猜測和分享的「驚天大秘密」。 ", id: 'D' },
                                ].map((option, optionIndex) => (
                                    <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                        <div className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let ans = [...question1SelectedAnswers]
                                                    if (ans.includes(option.id)) {
                                                        ans = ans.filter(a => a !== option.id)
                                                    } else {
                                                        ans.push(option.id)
                                                    }
                                                    setQuestion1SelectedAnswers(ans)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${question1SelectedAnswers.includes(option.id) ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: option.text }}></div>
                                        </div>
                                        <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                    </div>
                                ))}
                                <div className='w-full flex flex-row justify-end items-center'>
                                    <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={() => {
                                       if (question1SelectedAnswers.length === 1 && question1SelectedAnswers.includes('A')) {
                                            setQuestion1PopupVisible(true)
                                        } else {
                                            setShowWrongAnswerPopup(true)
                                        }
                                    }}>
                                        提交
                                    </div>
                                </div>

                            </div>


                        </div>


                        {/*question2*/}
                        <img src='/閱讀策略/4-04.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <div className='w-full bg-[#F0DDFB] flex flex-col justify-start p-[32px] items-center'>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                <u>太平山</u>頂纜車是香港第一輛載客纜車，也是全<u>亞洲</u>最早運作的纜車系統之一。自 1888 年通車以來，至 2026 年，<u>太平山</u>頂纜車已陪伴<u>香港</u>走過 138 年。纜車行駛時緩緩上升，車身傾斜而穩定，既方便市民和遊客登山，也成為許多人到<u>香港</u>必試的旅遊體驗之一。<br /><br />
                                纜車車廂經歷了六代演進，外型與功能都不斷改良。最早期的車廂以木頭製成，設計簡單；後來的車廂愈來愈舒適，安全設備也更完善。最新的第六代車廂特別加寬兩側玻璃窗，並加設透明天窗，讓乘客在上山途中可以更清楚欣賞<u>維多利亞港</u>、<u>港島</u>高樓與山下城市風光。
                                <br />
                                <br />
                                <img src='/閱讀策略/4-05.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                                資料來源：香港旅遊發展局https://www.discoverhongkong.com
                            </div>
                            <br /><br />
                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px] max-w-[600px] bg-[#D0E9FF] p-[16px]'>
                                <div className='w-full'>
                                    2.你在一個旅遊網站看到以下介紹：「太平山頂纜車自 1888 年通車，至 2026 年已有 138 年歷史。最新的第六代車廂在 2022 年開始使用，加闊兩側玻璃窗，並設有透明天窗，方便乘客欣賞風景。」你認為這段網站資料可信嗎？
                                </div>
                                {[
                                    { text: "A.	可信，因為旅遊網站是專門介紹旅遊資料，不會出錯。 ", id: 'A' },
                                    { text: "B. 可信，因為旅遊網站說的內容與香港旅遊發展局網頁介紹相符。", id: 'B' },
                                    { text: "C. 不可信，因為圖片顯示第六代纜車是 1989 年開始使用。", id: 'C' },
                                    { text: "D. 不可信，因為太平山頂纜車不只有六代車廂。", id: 'D' },
                                ].map((option, optionIndex) => (
                                    <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                        <div className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let ans = [...question2SelectedAnswers]
                                                    if (ans.includes(option.id)) {
                                                        ans = ans.filter(a => a !== option.id)
                                                    } else {
                                                        ans.push(option.id)
                                                    }
                                                    setQuestion2SelectedAnswers(ans)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${question2SelectedAnswers.includes(option.id) ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: option.text }}></div>
                                        </div>
                                        <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                    </div>
                                ))}
                                <div className='w-full flex flex-row justify-end items-center'>
                                    <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={() => {
                                         if (question2SelectedAnswers.length === 1 && question2SelectedAnswers.includes('B')) {
                                            setQuestion2PopupVisible(true)
                                        } else {
                                            setShowWrongAnswerPopup(true)
                                        }
                                    }}>
                                        提交
                                    </div>
                                </div>

                            </div>


                        </div>
                        <br />




                        {/*return button*/}
                        <button onClick={props.onClose} className='mt-4 px-4 py-2 bg-blue-500 text-white rounded m-[32px]'>返回</button>


                    </div>
                    {/*end of web content*/}




                </div>
                {/*end of webpages*/}






            </div>

            {question1PopupVisible && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <div className='w-full'>答案：A</div>
                        <div className='w-full max-w-[700px]'>
                            解析：我們可以用兩步來做判斷：首先「看來源」：網頁一是官方網站且有發言人負責，比網頁二的匿名網民更具公信力；接着「找證據」：網頁一承諾會公開投票數據，資訊公開透明，而網頁二只用「聽說」和「驚天大秘密」，拿不出任何實際證明，所以網頁一的訊息比網頁二更可靠。選項 A 完全符合這兩大可靠標準。
                        </div>
                        <button onClick={() => setQuestion1PopupVisible(false)} className='mt-4 px-[24px] py-2 text-white rounded-full bg-[#0000FF]' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}
            {question2PopupVisible && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <div className='w-full'>答案：B</div>
                        <div className='w-full max-w-[700px]'>
                            解析：我們可以用兩步來檢查：首先「看來源」，雖然這是旅遊網站，但我們不能盲目相信它不會出錯（排除A）；接着「找證據」，我們把網站的內容跟香港旅遊發展局網頁介紹對照，發現第一代通車年份和第六代的特徵完全吻合、能找到確切證據，所以答案是B。
                        </div>
                        <button onClick={() => setQuestion2PopupVisible(false)} className='mt-4 px-[24px] py-2 text-white rounded-full bg-[#0000FF]' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}
             {showWrongAnswerPopup && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <div className='w-full'>答錯了，請再嘗試！</div>
                        <button onClick={() => setShowWrongAnswerPopup(false)} className='mt-4 px-[24px] py-2 text-white rounded-full bg-[#0000FF]' style={{ border: '2px solid #0000FF' }}>返回</button>
                    </div>
                </div>
            )}




        </div>
    )
}